module.exports = __webpack_public_path__ + "img/title.3886daf7.png";